import queryString from 'querystring';
import _ from "lodash";
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ALBUM_MEDIAS_MULTI').plugin(axiosPlugin, {template:"multiArray"});

let fetchAlbumMediasAction = redux.fetchActionGet();


redux.reducerForType('ADD', (state,payload) => {
    let newState = {...state};
    payload.data.forEach(media => {
        newState[media.album].data.unshift(media);
        newState[media.album].total++;
    });
    return newState;
});

redux.reducerForType('DELETE', (state,payload) => {
    let newState = {...state};
    if(payload.data && payload.data._id){
        newState[payload.data.album].data = newState[payload.data.album].data.filter(item => item._id.toString() !== payload.data._id.toString());
        newState[payload.data.album].total--;
        if(newState[payload.data.album].total < 0){
            newState[payload.data.album].total = 0;
        }
    }
    return newState;
});

redux.reducerForType('UPDATE', (state,payload) => {
    let newState = {...state};
    if(_.get(payload,"data._id")){
        if(_.get(payload,"data.album._id")){
            newState[payload.data.album._id].data = newState[payload.data.album._id].data.map(item => {
                if(item._id.toString() === payload.data._id.toString()){
                    item = payload.data;
                }
                return item;
            });
        }
        else if(_.get(payload,"data.album")){
            newState[payload.data.album].data = newState[payload.data.album].data.map(item => {
                if(item._id.toString() === payload.data._id.toString()){
                    item = payload.data;
                }
                return item;
            });
        }

    }
    return newState;
});

export const fetchAlbumMediasMulti = (albumId, query = {}) => fetchAlbumMediasAction(`/albums/${albumId}/medias?${queryString.stringify(query)}`, null, {key:albumId});

// export const resetAlbumMediasMulti = (keys) => redux.actions.unsetKeys(keys);
export const resetAlbumMediasMulti = (keys) => {};

export const albumMediasMulti = redux.reducer();